import React, { useState, useEffect } from 'react';
import './GroupsComponents.css';

import ChildrenTableShort from '../TableChildren';
import GroupTabsFull from './GroupsTabsFull';
import GroupTabs from './GroupsTabsShort';
import AttendanceGroup from '../Attendance/AttendanceTable';
import FoodRatesTable from '../KitchenTable/FoodRatesTable';
import StatisticaAttendanceGroup from '../TabelGroup/StatisticaAttendanceGroup';
import ArchiveGroupsTabs from './ArchiveGroupsTabs/ArchiveGroupsTabs';
import TransferToNextYearModal from '../TransferToNextYear/TransferToNextYearModal';
import TransferToAnotherKindergartenModal from '../TransferToAnotherKindergarten/TransferToAnotherKindergartenModal';
import MenuPublicModal from '../../../../../components/MenuPublicView/MenuPublicModal';
import { MemberModal } from '../Team/TeamGallery';

import { getFreePlacesInfo } from '../helpers/freeplaces';

import imgDownSvg from '../../../../../img/arrow-down-fill.svg'

import UniversalModall, { useModal } from '../../../../../components/AlertModal/UniversalModal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faXmark, faGlobe, faUser } from '@fortawesome/free-solid-svg-icons';


import { getDisabilities, getAttendsInfo, resetPlacesGroup} from '../GroupDetail/actions';

import { getGroupsDictionary, constr_uri } from '../../../../../services/apiClient';
import { employeeAPI } from '../Employee/actions';


const sortByCc = (key, order = 'asc') => {
  return (a, b) => {
    if (a[key] === b[key]) return 0;
    
    // Проверяем тип для правильного сравнения строк и чисел
    if (typeof a[key] === 'string' && typeof b[key] === 'string') {
      return order === 'asc' 
        ? a[key].localeCompare(b[key]) 
        : b[key].localeCompare(a[key]);
    }
    
    return order === 'asc' 
      ? (a[key] > b[key] ? 1 : -1) 
      : (a[key] < b[key] ? 1 : -1);
  };
};

// ── Стилі для мобільного bottom-sheet (той самий підхід що в TeamGallery) ─────
let GROUP_SHEET_STYLES_INJECTED = false;
function injectGroupSheetStyles() {
  if (GROUP_SHEET_STYLES_INJECTED) return;
  GROUP_SHEET_STYLES_INJECTED = true;
  const s = document.createElement('style');
  s.textContent = [
    '.groupskg-sheet-overlay { position:fixed; inset:0; z-index:9999; background:rgba(0,0,0,0); transition:background 0.3s ease; pointer-events:none; }',
    '.groupskg-sheet-overlay.groupskg-sheet-visible { background:rgba(0,0,0,0.5); pointer-events:all; }',
    '.groupskg-sheet { position:fixed; left:0; right:0; bottom:0; z-index:10000; background:#fff; border-radius:20px 20px 0 0; max-height:92vh; display:flex; flex-direction:column; box-shadow:0 -8px 32px rgba(0,0,0,0.25); transform:translateY(100%); transition:transform 0.32s cubic-bezier(0.16,1,0.3,1); }',
    '.groupskg-sheet.groupskg-sheet-open { transform:translateY(0); }',
  ].join('\n');
  document.head.appendChild(s);
}

// ── Хук визначення мобільного екрану ──────────────────────────────────────────
function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
}

// ── Повноекранний bottom-sheet для групи на мобільному ────────────────────────
const GroupMobileSheet = ({ group, summary, onClose, children }) => {
  const [visible, setVisible] = useState(false);
  const [dragY, setDragY] = useState(0);
  const touchStartRef = React.useRef(null);
  const sheetRef = React.useRef(null);

  useEffect(() => {
    injectGroupSheetStyles();
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => setVisible(true));
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 280);
  };

  const handleTouchStart = (e) => {
    touchStartRef.current = e.touches[0].clientY;
  };
  const handleTouchMove = (e) => {
    if (touchStartRef.current === null) return;
    const dy = e.touches[0].clientY - touchStartRef.current;
    if (dy > 0) setDragY(dy);
  };
  const handleTouchEnd = () => {
    if (dragY > 100) {
      handleClose();
    } else {
      setDragY(0);
    }
    touchStartRef.current = null;
  };

  const sheetStyle = dragY > 0
    ? { transform: `translateY(${dragY}px)`, transition: 'none' }
    : undefined;

  return (
    <>
      <div
        className={`groupskg-sheet-overlay ${visible ? 'groupskg-sheet-visible' : ''}`}
        onClick={handleClose}
      />
      <div
        ref={sheetRef}
        className={`groupskg-sheet ${visible ? 'groupskg-sheet-open' : ''}`}
        style={sheetStyle}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Індикатор для свайпу */}
        <div style={{
          display: 'flex', justifyContent: 'center', padding: '10px 0 4px',
          flexShrink: 0, cursor: 'grab',
        }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: 'rgba(0,0,0,0.18)' }} />
        </div>

        {/* Кнопка закрити */}
        <button
          onClick={handleClose}
          style={{
            position: 'absolute', top: 14, right: 14, zIndex: 5,
            width: 32, height: 32, borderRadius: '50%',
            background: 'rgba(0,0,0,0.06)', border: 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#495057', fontSize: 15, cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        {/* "Обкладинка" — опис групи на місці фото */}
        <div style={{
          padding: '4px 24px 18px', flexShrink: 0,
          borderBottom: '1px solid #f0f0f0',
        }}>
          <div style={{ fontSize: 19, fontWeight: 700, color: '#212529', marginBottom: 6, paddingRight: 36 }}>
            {group.number} {group.name}
          </div>
          {summary}
        </div>

        {/* Контент — таби + таблиця, скролиться, на всю ширину */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '0 16px 24px', WebkitOverflowScrolling: 'touch' }}>
          {children}
        </div>
      </div>
    </>
  );
};

// Картка вихователя: скруглена "таблетка" — зліва кругле фото, справа
// Прізвище Ім'я. Якщо у educator є employeeId — беремо ФІО/фото живими з
// довідника працівників (employeesById), інакше показуємо збережений текст.
// Клік по картці — та сама модалка профілю, що й у розділі "Команда".
const EducatorCard = ({ educator, employeesById }) => {
  const emp = educator.employeeId ? employeesById[educator.employeeId] : null;
  const lastName = emp?.lastName || educator.lastName || '';
  const firstName = emp?.firstName || educator.firstName || '';
  const avatarFileId = emp?.publicProfile?.avatarFileId || emp?.photos?.[0]?.id;
  const avatarSrc = emp?.photoDocId && avatarFileId
    ? constr_uri(`docfile?doc_id=${emp.photoDocId}&file_id=${avatarFileId}`)
    : null;

  const cardRef = React.useRef(null);
  const [modalRect, setModalRect] = useState(null);

  const getAdjustedRect = (rect) => ({
    top: rect.top - window.scrollY,
    left: rect.left - window.scrollX,
    width: rect.width,
    height: rect.height,
  });

  const handleClick = (e) => {
    e.stopPropagation(); // не даємо кліку "спливти" до заголовка групи (він розгортає/згортає групу)
    if (!emp || !cardRef.current) return; // немає прив'язки до працівника — нема що відкривати
    const rect = cardRef.current.getBoundingClientRect();
    setModalRect({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
      height: rect.height,
    });
  };

  const member = emp ? {
    id: emp._id,
    fullName: emp.fullName || [lastName, firstName].filter(Boolean).join(' '),
    position: (emp.publicProfile && emp.publicProfile.publicPosition) ||
      (emp.departments && (emp.departments.find(d => d.selected) || emp.departments[0])?.positionName) || '',
    photoDocId: emp.photoDocId,
    avatarFileId,
    bio: (emp.publicProfile && emp.publicProfile.bio) || '',
    displayGroup: 2 // "Вихователі та педагоги" — той самий тег, що і в Команді
  } : null;

  return (
    <>
      <div
        ref={cardRef}
        onClick={handleClick}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          background: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: 999,
          padding: '4px 12px 4px 4px',
          cursor: emp ? 'pointer' : 'default'
        }}
      >
        <div style={{
          width: 32, height: 32, borderRadius: '50%', overflow: 'hidden',
          background: '#dee2e6', flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          {avatarSrc ? (
            <img src={avatarSrc} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <FontAwesomeIcon icon={faUser} style={{ color: '#adb5bd', fontSize: 14 }} />
          )}
        </div>
        <span style={{ fontSize: 13 }}>{[lastName, firstName].filter(Boolean).join(' ') || 'Не вказано'}</span>
      </div>

      {modalRect && member && (
        // Обгортка з stopPropagation — оверлей/кнопки модалки самі не
        // зупиняють клік, а вона рендериться в тому ж DOM-піддереві, що й
        // клікабельний заголовок групи (він розгортає/згортає групу).
        <div onClick={(e) => e.stopPropagation()}>
          <MemberModal
            members={[member]}
            startIndex={0}
            originRect={getAdjustedRect(modalRect)}
            onClose={() => setModalRect(null)}
          />
        </div>
      )}
    </>
  );
};

// Компонент группы
const GroupItem = ({ index, group, isExpanded, onToggle, children, isKgHead=false, onEditGroup, isArchive, mode, attInfo, employeesById }) => {

  const isMobile = useIsMobile();

  const free_info= getFreePlacesInfo(group);

  const isHasPlanedInclusiveAmount = (group) =>{

    const { placesAmount, planedAmount} = group;

    return ["inclusive", "inclusiveShort"].filter(k=>placesAmount[k] || planedAmount[k]).length > 0;

  }


  const { free_places, places_amount, aval } = free_info;
  
  const disabilitiestypesList = getDisabilities();

  const disText = group.disabilitiesType && disabilitiestypesList?.find(r=>r._id == group.disabilitiesType) ? '( ' + disabilitiestypesList?.find(r=>r._id == group.disabilitiesType).label + ' )' : '';


  
  const allCount = Object.keys(places_amount).reduce((a,c)=>{ return a + places_amount[c]}, 0);
  
  const PlacesAll = (_props)=>{

    const { free_places, places_amount, aval } = _props;


    const freeAll = Object.keys(free_places).filter(k=>!k.match(/\.diff/)).reduce((a,c)=>{ return a + free_places[c]}, 0);

    const isErrorPlaces = Object.keys(free_places).filter(k=>k.match(/\.diff/)).reduce((a,c)=>{ return a || free_places[c] < 0}, false);

    return (<div className="groupskg-group-availability"> Місць всього: 
            <strong>{allCount}</strong> {" ,"} вільних: { ' ' }
            <strong>{freeAll}</strong> 
            <span className="groupskg-sep-dot"></span>{' '}
            <span className={`groupskg-muted ${aval ? 'groupskg-available' : 'groupskg-unavailable'}`}>
              {aval ? 'місця наявні' : 'місць немає'}
            </span>
             <span  title='У цій групі місць менше, ніж дітей.' ><FontAwesomeIcon icon={faCircleExclamation} style={{ color: "#dc3545", visibility: isErrorPlaces ? 'visible' : 'hidden'}}/></span>
          </div>)

  }

  const PlacesType = (_props)=>{
    
    const { free, amount, name, placesAmount, type = ""} = _props;

    

    if( (allCount == amount) && (type == "standart") ) return null;

    if(free == 0 && amount == 0 ) return null;


    

    return (<div className="groupskg-group-availability"> {name}: 
            <strong>{amount}</strong> {" ,"} вільних: { ' ' }
            <strong>{free}</strong> 
            <span className="groupskg-sep-dot"></span>{' '}
            <span className={`groupskg-muted ${free ? 'groupskg-available' : 'groupskg-unavailable'}`}>
              {free ? 'місця наявні' : 'місць немає'}
            </span>
          </div>)
  
  }

  const OldInfo = (_props)=>{
    return <div className="groupskg-group-availability">
            <strong>{free_places['standart']}</strong> з{ ' ' }
            <strong>{places_amount['standart']}</strong> повного дня
            <span className="groupskg-sep-dot"></span>{' '}
            <strong>{free_places['without-bed']}</strong> з{' '}
            <strong>{places_amount['without-bed']}</strong> короткотривалого перебування
            <span className="groupskg-sep-dot"></span>{' '}
            {isHasPlanedInclusiveAmount(group) && <><strong>{free_places['inclusive'] + (free_places['inclusive-short'] || 0)}</strong> з{' '}
            <strong>{places_amount['inclusive'] + (places_amount['inclusive-short'] || 0) }</strong> інклюзивних місць</> || null}
            <span className={`groupskg-muted ${aval ? 'groupskg-available' : 'groupskg-unavailable'}`}>
              {aval ? 'місця наявні' : 'місць немає'}
            </span>
          </div>
  }

  // Блок опису групи — переюзається і в шапці картки (завжди видимий),
  // і зверху мобільного bottom-sheet (замість "фото")
  const SummaryBlock = () => (
    <>
      <div className="groupskg-group-subtitle">
        {group.subtitle}
        <span className="groupskg-sep-dot"></span>
        {group.type}, {group.specifics} {disText}
      </div>
      <div>
        <PlacesAll free_places={free_places}  places_amount={places_amount}  aval={aval}/>
        {allCount != places_amount['standart'] && <div className='nav-divider' />}
        <PlacesType
          free={free_places["standart"]}
          amount={places_amount["standart"]}
          name="повного дня"
          places_amount={places_amount}
          type = "standart"
          />
        <PlacesType
          free={free_places["without-bed"]}
          amount={places_amount["without-bed"]}
          name="короткотривалого перебування"
          places_amount={places_amount}/>
        <PlacesType
          free={free_places["inclusive"]}
          amount={places_amount["inclusive"]}
          name="інклюзивних"
          places_amount={places_amount}/>
        <PlacesType
          free={free_places["inclusive-short"]}
          amount={places_amount["inclusive-short"]}
          name="інклюзивних короткотривалого перебування"
          places_amount={places_amount}/>
        <div></div>
        {attInfo?.tabel_days && attInfo?.tabel_days[group._id] && <span>
            {' '} Відвідування на сьогодні/середнє за місяць: {' '}{attInfo?.tabel_curdate[group._id]} / {Math.round(attInfo?.tabel_info[group._id]/attInfo?.tabel_days[group._id])}
        </span>}
      </div>
      <div className="groupskg-teachers groupskg-small groupskg-text-muted groupskg-mb-2" style={{ marginTop: 8 }}>
        <div style={{ marginBottom: 4 }}>Вихователі:</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {(group.educators || []).length === 0 ? (
            <span className="groupskg-text-body-teachers">Не вказано</span>
          ) : (
            group.educators.map((ed, idx) => (
              <EducatorCard key={ed.employeeId || idx} educator={ed} employeesById={employeesById} />
            ))
          )}
        </div>
      </div>
    </>
  );

  const handleHeaderClick = () => {
    onToggle();
  };

  return (
    <div className="groupskg-group-item">
      <div 
        className={`groupskg-group-header ${isExpanded ? 'groupskg-expanded' : 'groupskg-collapsed'}`}
        onClick={handleHeaderClick}
      >
        <div className="groupskg-group-header-content">
          <span className="groupskg-group-index">{index}</span>
          <div className="groupskg-group-title-wrap">
            <div className="groupskg-group-title">{group.number} {group.name}</div>
            {group.internationalAgreement && (
              <span className="groupskg-badge-international" title="Група за міжнародною угодою">
                <FontAwesomeIcon icon={faGlobe} /> Міжнародна угода
              </span>
            )}
          </div>
          <div className="groupskg-group-actions">
            {isKgHead && <a href="" className="groupskg-link-primary groupskg-small groupskg-text-nowrap" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); onEditGroup(group._id) }}>
               {mode == "edit" ? 'Редагувати' : "Опис групи" }
            </a>}
            <a href="" className="groupskg-link-primary groupskg-small groupskg-text-nowrap groupskg-expand-label" onClick={(e)=>e.preventDefault()}>
              {isExpanded ? 'Згорнути' : 'Детальніше'}
            </a>
            <img
              src={imgDownSvg}
              alt="expand"
              className={`groupskg-expand-icon ${isExpanded ? 'groupskg-expanded' : ''}`}
            />
          </div>
        </div>
        <div className="groupskg-group-head-text">
          <SummaryBlock />
        </div>
      </div>

      {/* Десктоп — звичайний inline-акордеон, без змін */}
      {isExpanded && !isMobile && (
        <div className="groupskg-group-content">
          {children}
        </div>
      )}

      {/* Мобільний — повноекранний bottom-sheet, опис групи зверху
          (на місці "фото" за аналогією з карткою співробітника),
          таблиця нижче на всю ширину екрану */}
      {isExpanded && isMobile && (
        <GroupMobileSheet
          group={group}
          summary={<SummaryBlock />}
          onClose={onToggle}
        >
          {children}
        </GroupMobileSheet>
      )}
    </div>
  );
};


// Компонент списка групп
export const GroupsList = ({ 
    groups, 
    isKgHead = false, 
    id, 
    onEditGroup, 
    onActionSelect, 
    period, 
    setCount, 
    isArchive,
    mode,
    onSelectedDate,
    isAdmin,
    onGroupsChanged
   }) => {
  const [expandedGroup, setExpandedGroup] = useState(null);
  const [activeTab, setActiveTab] = useState('kids');
  const [selectedDate, setSelectedDate] = useState(isArchive ? `${period}-09-01` : new Date().toISOString());
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [selectedPeriod, setPeriod ] = useState(null);
  const [typesGroup, setTypesGroup] = useState([]);
  const [transferGroup, setTransferGroup] = useState(null);
  const [menuGroup, setMenuGroup] = useState(null);
  // Переведення дітей, зроблені у поточній сесії, за id групи-джерела:
  // { [currentGroupId]: { [childId]: { groupId, groupNumber, groupName } } }.
  // Потрібно, щоб модалка одразу знала про щойно зроблені перекази (і могла їх
  // скасувати), не чекаючи, поки `groups` (пропс з бекенду) перезавантажиться
  // у батьківському компоненті.
  const [transferredChildrenByGroup, setTransferredChildrenByGroup] = useState({});
  // Група, для якої зараз відкрита модалка масового переведення до іншого садочка.
  const [transferExternalGroup, setTransferExternalGroup] = useState(null);
  // Активні працівники садочка — щоб показувати живі ФІО/фото вихователів,
  // прив'язаних до групи через educators[].employeeId.
  const [employeesById, setEmployeesById] = useState({});


  const {
      modalProps,
      alert,
      confirm,
      prompt,
      success,
      error,
      warning,
      Modal
  } = useModal();


  const handleClear = async () => {
      await resetPlacesGroup(id);
      alert('Всі місця у всіх групах обнулені');
  };
  

  const handleGroupToggle = (groupId) => {
    setActiveTab('kids');
    setSelectedDate(isArchive ? `${period}-09-01` : new Date().toISOString());
    setExpandedGroup(expandedGroup === groupId ? null : groupId);
  };

  const attInfo = async ()=>{

       const attInfo = await getAttendsInfo({kg_id: id});
     
       setAttendanceInfo(attInfo);
  };

  useEffect(()=>{
     if(id) attInfo();
  },[id]);

  useEffect(()=>{
    if(!id) return;
    const loadEmployees = async () => {
      try {
        const list = await employeeAPI.getActiveEmployees(id);
        const byId = {};
        (list || []).forEach(emp => { byId[emp._id] = emp; });
        setEmployeesById(byId);
      } catch (error) {
        console.error('Помилка завантаження працівників для карток груп:', error);
      }
    };
    loadEmployees();
  },[id]);

  useEffect(()=>{
    const api = async ()=>{
      const res = await getGroupsDictionary();
      setTypesGroup(res);
    }

    api();

  },[])

  useEffect(()=>{

    if(setCount && groups) {
      setCount(groups.length > 0);
      
    };

    if(groups?.length > 0) setPeriod(groups.map(gr=>+gr.periodStartYear)[0]);

  },[period, groups])

  useEffect(()=>{
    setSelectedDate(isArchive ? `${period}-09-01` : new Date().toISOString());
  },[isArchive, period])

  useEffect(()=>{
    if(!onSelectedDate) return;
    onSelectedDate(selectedDate);
  },[selectedDate]);

  const Tabs = (props)=>{
    if(isKgHead) { 
      return GroupTabsFull(props)
    }
    else {
      return GroupTabs(props)
    } 
  }

  
  const prep_groups_transfer = groups;

  const getPeriods = (groups)=>{
    const periods = {};

    for(let gr of groups){
      if(!periods[gr.periodStartYear]) periods[gr.periodStartYear] = 0;
      periods[gr.periodStartYear] += 1;
    }

    return Object.keys(periods).sort().map(p=>({value: p, label: `${p}-{${p+1}`}));
  }

  if(!groups) return null;


    const getGroupInfoByNumber = (numberGr) => {


      if (!numberGr || !groups) return null;
      const group = groups.find(g => g.number === numberGr);      
      if (!group || !group._id) return null;
      const { _id, name, number, periodStartYear } = group;
      return { _id, name, number, periodStartYear };

    };

    // Той самий підбір вікової дужки, що й на бекенді (models/kitchen_menu.js
    // bracketForAgeLimit) — тільки для того, щоб одразу відкрити потрібну вкладку в модалці
    // меню, а не змушувати перемикати вручну.
    const AGE_BRACKETS = [
      { label: '1-3 роки', from: 1, to: 3 },
      { label: '3-6 років', from: 3, to: 6 },
      { label: '6-10 років', from: 6, to: 10 }
    ];
    const bracketForAgeLimit = (ageLimit) => {
      if (!ageLimit || typeof ageLimit.from !== 'number' || typeof ageLimit.to !== 'number') return undefined;
      let best, bestOverlap = -Infinity;
      AGE_BRACKETS.forEach(b => {
        const overlap = Math.min(ageLimit.to, b.to) - Math.max(ageLimit.from, b.from);
        if (overlap > bestOverlap) { bestOverlap = overlap; best = b.label; }
      });
      return best;
    };


  return (
    <ArchiveGroupsTabs
      periods={getPeriods(groups)}
      isEmpty={false}
      onChange={(period)=>setPeriod(period)}
      onClick={handleClear}
      textButton='Обнулити місця садочку'
      showButton={isAdmin}
    >
  
    <div className="groupskg-groups-list">
      {groups?.filter(gr=>gr.periodStartYear == selectedPeriod).filter(gr=>isKgHead || !typesGroup.filter(t=>t.unvisible).map(t=>t.number).includes(gr.typeNumber)).sort(sortByCc('number', 'asc')).map((group, index) => (
        <GroupItem
          key={group._id}
          group={group}
          isExpanded={expandedGroup === group._id}
          onToggle={() => handleGroupToggle(group._id)}
          index={index +1}
          onEditGroup={onEditGroup}
          isKgHead={isKgHead}
          isArchive={isArchive}
          period={period}
          mode={mode}
          attInfo={attendanceInfo}
          employeesById={employeesById}
        >
          <Tabs activeTab={activeTab} 
            onTabChange={setActiveTab} 
            periodStartYear={group.periodStartYear}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            mode={mode}
            onTransferClick={() => setTransferGroup(group)}
            onTransferExternalClick={() => setTransferExternalGroup(group)}
            onMenuClick={() => setMenuGroup(group)}
            isAdmin={isAdmin}
          >

          {activeTab === 'kids' && <ChildrenTableShort 
              id={id} 
              group_id={group._id}
              onActionSelect={(actionId, child_id, group_id, child_tabelNumber, child_food)=>{ 
                onActionSelect(actionId, child_id, group_id, child_tabelNumber, child_food)}}
              groupNumber={group.number}
              groupName={group.name}
              allGroups={prep_groups_transfer}
              isArchive={isArchive}
              period={period}
              selectedDate={selectedDate}
              mode={mode}
              chgr={group.children}
              isAdmin={isAdmin}
              getGroupInfoByNumber={getGroupInfoByNumber}
              />}

            {activeTab === 'kids_left' && <ChildrenTableShort 
              id={id} 
              group_id={group._id}
              onActionSelect={(actionId, child_id, group_id, child_tabelNumber, child_food)=>{ 
                onActionSelect(actionId, child_id, group_id, child_tabelNumber, child_food)}}
              groupNumber={group.number}
              groupName={group.name}
              allGroups={prep_groups_transfer}
              isArchive={isArchive}
              period={period}
              selectedDate={selectedDate}
              mode={mode}
              chgr={group.children}
              isLeft={true}
              isAdmin={isAdmin}
              />}

            {activeTab === 'attendance' && <AttendanceGroup
                gr_id={group._id}
                showIdGroup={group._id}
                KinderGarten={groups}
                closePar={()=>{}}
                kg_id={id}
                groups={groups}
                periodStartYear={group.periodStartYear}
                selectedDate={selectedDate}
                mode={mode}
            />}
            {activeTab === 'table' && <StatisticaAttendanceGroup
                kgId={id}
                group={group}
                periodStartYear={group.periodStartYear}
                selectedDate={selectedDate}
                isArchive={isArchive}
                viewMode='group'
            />}
            {activeTab === 'tarifs' && <FoodRatesTable
              data={group.price}
            />}
          </Tabs>
        </GroupItem>
      ))}
    </div>
    <Modal />
    <MenuPublicModal
      show={!!menuGroup}
      onClose={() => setMenuGroup(null)}
      kindergartenId={id}
      defaultAgeGroup={menuGroup ? bracketForAgeLimit(menuGroup.ageLimit) : undefined}
    />
    <TransferToNextYearModal
      show={!!transferGroup}
      onHide={() => setTransferGroup(null)}
      kgId={id}
      currentGroup={transferGroup}
      allGroups={groups}
      transferOverrides={transferGroup ? (transferredChildrenByGroup[transferGroup._id] || {}) : {}}
      onTransferSuccess={(childrenIds, targetGroup) => {
        if (transferGroup && targetGroup) {
          setTransferredChildrenByGroup(prev => {
            const prevMap = prev[transferGroup._id] || {};
            const nextMap = { ...prevMap };
            (childrenIds || []).forEach(chId => {
              nextMap[chId] = {
                groupId: targetGroup._id,
                groupNumber: targetGroup.number,
                groupName: targetGroup.name,
                groupType: targetGroup.type,
                groupAgeLimit: targetGroup.ageLimit
              };
            });
            return { ...prev, [transferGroup._id]: nextMap };
          });
        }
        if (onGroupsChanged) onGroupsChanged();
      }}
      onCancelSuccess={(childId) => {
        if (transferGroup) {
          setTransferredChildrenByGroup(prev => {
            const prevMap = prev[transferGroup._id] || {};
            if (!(childId in prevMap)) return prev;
            const nextMap = { ...prevMap };
            delete nextMap[childId];
            return { ...prev, [transferGroup._id]: nextMap };
          });
        }
        if (onGroupsChanged) onGroupsChanged();
      }}
    />
    <TransferToAnotherKindergartenModal
      show={!!transferExternalGroup}
      onHide={() => setTransferExternalGroup(null)}
      kgId={id}
      sourceGroup={transferExternalGroup}
      onSuccess={() => {
        if (onGroupsChanged) onGroupsChanged();
      }}
    />
    </ArchiveGroupsTabs>
  );
};

// Основной компонент
const GroupsComponent = (onActionSelect) => {
 
  const groupsData = [
    {
      id: 1,
      index: 1,
      title: "2024-2025 Група «Квітки»",
      subtitle: "Старша група — від 5-ти до 6-ти років",
      type: "Загального розвитку (без спеціалізацій)",
      availability: {
        full: { current: 5, total: 20 },
        short: { current: 1, total: 4 },
        inclusive: { current: 1, total: 2 }
      },
      available: false,
      teachers: "Онищук Таіса Петрівна, Чуприна Анна Євгенівна",
      children: [
        {
          lastName: "Шевченко",
          firstName: "Тарас",
          middleName: "Григорович",
          birthDate: "15.10.2023",
          documentNumber: "ІІ-БК908367",
          enrollmentDate: "01.01.2025",
          placeType: "Повного дня",
          foodType: "Звичайний"
        }
        // ... другие дети
      ]
    }
    // ... другие группы
  ];

  return (
    <div className="groupskg-groups-container">
      <div className="groupskg-toolbar">
        <button className="groupskg-btn-gr groupskg-btn-primary groupskg-btn-add">
          <i className="fa fa-plus groupskg-me-2"></i>Додати групу
        </button>
        <input
          type="search"
          className="groupskg-form-control groupskg-search-input"
          placeholder="Швидкий пошук"
          aria-label="Швидкий пошук"
        />
      </div>

      <GroupsList groups={groupsData} onActionSelect={onActionSelect}/>
    </div>
  );
};

export default GroupsComponent;